export const signIn = {
  header: 'Sign In',
  labels: {
    emailAddress: 'Email address',
    password: 'Password',
    rememberMe: 'Remember me',
    signIn: 'Sign In',
    forgotPassword: 'Forgot Password'
  },
  errors: {
    auth: 'Invalid email or password.',
    email: 'Email must be a valid email'
  }
};
